import React from 'react';
import type { ViewControl } from 'src/components/star-grid/api/reportEngineTypes';
import { ReportVersionSelector } from 'src/components/star-grid/components/ReportVersionSelector';
import { useReportVersionPicker } from 'src/components/star-grid/hooks/useReportVersionPicker';

interface Props {
  readonly reportId?: string;
  readonly control: ViewControl;
  readonly onPick: (controlId: string, value: string) => void;
}

/** A comparison's Version 1 / Version 2: the same snapshot-and-tag picker as the report's Version, each with its own pick. */
export const CompareVersionSelector: React.FC<Props> = ({ reportId, control, onPick }) => {
  const picker = useReportVersionPicker(reportId, control.value, (value) => onPick(control.id, value));
  return (
    <ReportVersionSelector
      label={control.label}
      controlId={`stargrid-report-version-${control.id}`}
      control={picker.control}
      choices={picker.choices}
    />
  );
};
